// extracted by mini-css-extract-plugin
export var anchored = "contactDepartment-module--anchored--31fec";
export var contactButton = "contactDepartment-module--contactButton--6c44f";
export var contactDepartmentOuterContainer = "contactDepartment-module--contactDepartmentOuterContainer--57597";
export var contentDepartmentContainer = "contactDepartment-module--contentDepartmentContainer--f3dbe";
export var departmentLink = "contactDepartment-module--departmentLink--ecb83";
export var departmentTextContainer = "contactDepartment-module--departmentTextContainer--dc5b2";
export var iconTextPair = "contactDepartment-module--iconTextPair--3a831";
export var imageContainer = "contactDepartment-module--imageContainer--0ad72";
export var leftContainer = "contactDepartment-module--leftContainer--83d31";
export var phoneBlock = "contactDepartment-module--phoneBlock--9696d";
export var removePadding = "contactDepartment-module--removePadding--52e4b";
export var sectionOne = "contactDepartment-module--sectionOne--2eadb";
export var sectionTwo = "contactDepartment-module--sectionTwo--5650b";